// ============================================================
// 真实后端实现（xiaoyuan/server：Node + Express + MySQL）
//   接口清单与参数名严格对照后端路由与设计文档「四、后端 API 全景」
//   返回结构 = 后端的 { state:{type,msg}, data, count }，与 mock 层一致
// ============================================================
import http from './http'

// ---------------- 登录态（从 localStorage 读取） ----------------
export const getCurrentUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userinfo') || 'null')
  } catch (e) {
    return null
  }
}

export const requireLogin = () => {
  const u = getCurrentUser()
  if (!localStorage.getItem('luffy_jwt_token') || !u) throw new Error('NOT_LOGIN')
  return u
}

// ---------------- 公共：分类 / 轮播（后端白名单，免登录） ----------------
export const getLable = (lable_name) => http.post('/admin/lablelist', { lable_name })
export const getCarousels = () => http.post('/admin/carousellist', { lable_name: '' })

// ---------------- 列表 ----------------
export const getHelpList = (params = {}) =>
  http.post('/web/webgetwebhelplist', {
    lable: params.lable || '',
    tag: params.tag || '',
    page: params.page || 1,
    pagesize: params.pagesize || 10
  })

export const getActivityList = (params = {}) =>
  http.post('/web/webgetwebactivitylist', {
    lable: params.lable || '',
    page: params.page || 1,
    pagesize: params.pagesize || 10
  })

export const getJobList = (params = {}) =>
  http.post('/web/webgetjoblist', {
    lable: params.lable || '',
    tag: params.tag || '',
    page: params.page || 1,
    pagesize: params.pagesize || 10
  })

export const getArticleList = (params = {}) =>
  http.post('/web/getarticlelist', {
    lable: params.lable || '',
    tag: params.tag || '',
    page: params.page || 1,
    pagesize: params.pagesize || 5
  })

export const getOldstuffList = (params = {}) =>
  http.post('/web/webgetweboldstufflist', {
    lable: params.lable || '',
    page: params.page || 1,
    pagesize: params.pagesize || 12
  })

export const getCompanyList = (params = {}) =>
  http.post('/web/webgetcompanylist', {
    lable: params.lable || '',
    tag: params.tag || '',
    page: params.page || 1,
    pagesize: params.pagesize || 10
  })

// ---------------- 详情 ----------------
export const getHelpContent = (id) => http.post('/web/gethelpcontent', { id })
export const getActivityContent = (id) => http.post('/web/getactivitycontent', { id })
export const getJobContent = (id) => http.post('/web/getjobcontent', { id })
export const getArticleContent = (id) => http.post('/web/getarticlecontent', { id })
export const getOldstuffContent = (id) => http.post('/web/getoldstuffcontent', { id })
export const getCompanyContent = (id) => http.post('/web/getcompanycontent', { id })

// 活动公告（需登录）
export const getAnnouncementList = (content_id) => http.post('/admin/announcementlist', { content_id })

// ---------------- 报名 / 购买意向（需登录） ----------------
export const setJoin = (params = {}) => http.post('/web/setjoin', params)

// ---------------- 全站搜索 ----------------
export const searchAll = (keyword) => http.post('/web/search', { search: keyword || '' })

// ---------------- 评论 / 回复 ----------------
export const getComment = (content_id) => http.post('/web/getcomment', { content_id })
export const setComment = (params = {}) => http.post('/web/setcomment', params)
export const getReply = (comment_id) => http.post('/web/getreply', { comment_id })
export const setReply = (params = {}) => http.post('/web/setreply', params)

// ---------------- 消息通知（需登录） ----------------
export const getNotice = (params = {}) =>
  http.post('/web/getnotice', { num: params && params.num ? params.num : '' })
export const changeNotice = (params = {}) => http.post('/web/changenotice', params)

// ---------------- 注册 / 登录 / 退出 ----------------
export const registered = (params = {}) => http.post('/webadmin/registered', params)

// 登录：后端返回 { state, data:{ shensu, token, userinfo } }
// 被封禁时后端返回 { state:'s', data: 解封时间戳 }（注意 state 是字符串，做兼容处理）
export const login = (params = {}) =>
  http.post('/webadmin/login', params).then((res) => {
    if (res && res.state === 's') {
      return { state: { type: 's', msg: '账号因不良行为被限制登录' }, data: { activationdate: res.data } }
    }
    return res
  })

export const logout = () => {
  localStorage.removeItem('luffy_jwt_token')
  localStorage.removeItem('userinfo')
  return Promise.resolve({ state: { type: 'SUCCESS', msg: '已退出' }, data: {} })
}
